import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Divider, Grid, InputAdornment, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import * as React from 'react';

import DeleteIconButton from '../components/DeleteIconButton';
import PageHeading from '../components/PageHeading';
import StyledFilledTextField from '../components/StyledFilledTextField';

// Strings-style (Notifications > Strings) mobile layout shared by the
// bus tour list pages (CP-8233).

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        maxHeight: '100%',
        minHeight: 0,
        overflow: 'hidden',
        backgroundColor: '#FCFCFE',
        paddingBottom: theme.spacing(1),
    },
    pageHeader: {
        flexShrink: 0,
        backgroundColor: '#FCFCFE',
        zIndex: 2,
    },
    listRegion: {
        flex: 1,
        minHeight: 0,
        maxHeight: 'calc(100dvh - 11rem)',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
}));

const BusTourListMobileLayout = ({ title, searchLabel, searchValue, onSearchChange, actionButton, children }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Box className={classes.pageHeader}>
                <Box display="flex" justifyContent="space-between" alignItems="center" px={1} pt={2}>
                    <PageHeading sx={{ mb: 1.5 }}>{title}</PageHeading>
                </Box>
                <Box px={1} pb={1} display="flex" alignItems="center" gap={1}>
                    <StyledFilledTextField
                        label={searchLabel}
                        size="small"
                        value={searchValue}
                        onChange={onSearchChange}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                        sx={{ flex: 1, minWidth: 0 }}
                    />
                    {actionButton}
                </Box>
            </Box>
            <Box className={classes.listRegion}>{children}</Box>
        </div>
    );
};

// CP-5545: with rows selected the [+] becomes the red trash, disabled (not swapped back to [+]) without the delete permission.
export const BusTourMobileActionButton = ({ selectedCount, canDelete, onDelete, onAdd, addLabel, deleteLabel }) =>
    selectedCount > 0 ? (
        <DeleteIconButton title={deleteLabel} size="medium" fontSize="medium" allowed={canDelete} onClick={onDelete} sx={{ flexShrink: 0 }} />
    ) : (
        <Button variant="contained" onClick={onAdd} sx={{ flexShrink: 0 }} aria-label={addLabel}>
            <AddIcon />
        </Button>
    );

export const BusTourMobileListItem = ({ name, onOpen, details, actions, isLast }) => (
    <>
        <Grid container spacing={1} p={2} alignItems="center">
            <Grid item xs={12}>
                <Typography
                    style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}
                    fontWeight={600}
                    onClick={onOpen}
                    sx={{ cursor: onOpen ? 'pointer' : undefined }}
                >
                    {name}
                </Typography>
            </Grid>
            <Grid item xs={12} sx={{ cursor: onOpen ? 'pointer' : undefined }} onClick={onOpen}>
                {details}
            </Grid>
            <Grid item xs={12} container justifyContent="flex-start" spacing={0.5} alignItems="center">
                {actions}
            </Grid>
        </Grid>
        {!isLast ? <Divider /> : null}
    </>
);

export default BusTourListMobileLayout;
